import React, { FC } from 'react';
import { GuestSiteEvent } from '@apps/guest/packages/layout-engine/layouts/layout.types';
import { useGuestSiteDebugger } from '@apps/guest/components/GuestSiteDebugger/GuestSiteDebugger.controller';

export type Props = {
  event: GuestSiteEvent;
};

export const GuestSiteDebugger: FC<Props> = ({ event }) => {
  const DebugInfo = (
    <div>
      <ul>
        <li>
          is charm: <strong>true</strong>
        </li>
        <li>
          event id: <strong>{event.id}</strong>
        </li>
        <li>
          firebase id: <strong>{event.firebaseId}</strong>
        </li>
      </ul>
    </div>
  );

  useGuestSiteDebugger({ content: DebugInfo });

  return <></>;
};
